export default {
	'common':{
		'select':'Izberi',
		'graph_loading': "Nalaganje...",
		'month_Names': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
		'graph_shortMonths': ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Avg', 'Sep', 'Okt', 'Nov', 'Dec'],
		'graph_day_name': ['Nedelja', 'Ponedeljek', 'Torek', 'Sreda', 'Četrtek', 'Petek', 'Sobota'],
		'graph_export': "Izvozi",
		'graph_printButt': "Natisni graf",
		'graph_down_PNG': "Shrani kot PNG",
		'graph_down_JPG': "Shrani kot JPEG",
		'graph_down_PDF': "Shrani kot PDF",
		'graph_down_SVG': "Shrani kot SVG",
		'graph_zoom_reset': "Resetiraj zoom",
		'Valid request.': 'Zahteva sprejeta',
		'Warning': 'Opozorilo',
	},
	'main':{
		'titleStatistics':'Statistika',
		'titleManual':'Navodila',
		'titleDownload':'Prenesi',
		'titleArchives':'Arhiv',
		'titleStream':'V Živo',
		'titleRealtime':'Realna meritev',
		'titlePlay':'Predvajaj',
		'titleDanger':'Napaka/Ne meri',
		'titleWarning':'Predvajaj',
		'titleSettings':'Nastavitve',
		'titleSD':'SD prosto:',
		'titleHDD':'SSD prosto:',
		'titleCamera': 'KAMERA:',
		'titleLogout': 'Odjavi',
		'status':'Status',
		'error':'Napaka',
		'running':'Merjenje',
		'notRunning': 'Ne meri',
		'downloadingFile':'Prenašanje datoteke',
		'preparingFile':'Datoteka se pripravlja'
	},
	'login':{
		'Username':'Up. Ime',
		'Password':'Geslo',
		'Login':'Vstopi',
	},
	'dashboard':{
		'measuringTgl':'MERITEV',
		'noiseTgl':'HRUP',
		'weatherTgl':'VREME',
		'adioTgl':'ADIO'
	},
	'graphs':{
		'export':{
			'Print chart':'Natisni graf',
			'Download':'Prenesi',
			'image':'sliko',
		},
		'nodata': "NI PODATKOV",
		'errNoise': "Problem z Nor140 napravo",
		'errWeath': "Problem z Vremensko postajo",
		'errAdio': "Problem z ADIO napravi",
		'NOISE':'HRUP',
		'SPECTRUM':'SPEKTER',
		'WEATHER':'VREME',
		'ADIO': 'ADIO',
		'STATISTICS':'STATISTIKA',
		'statTitle':'Naslov',
		'statFrom':'Od',
		'statTo':'Do',
		'load':'Naloži',
		'markers':'Markerji',
	    'dailyNotes': 'Dnevni zaznamki',
	    'preload': 'Ročno nalaganje grafa',
	    'sync': 'Sinhroniziraj grafe',
	    'reset': 'Resetiraj zoom',
	    'exportGraph': 'Izvozi graf',
	    'hideShow': 'Skrij / Prikaži',
		'markersCat':{
			'type':'Tip',
			'color':'Barva',
			'single': 'Točkovni',
			'toggle': 'Območje',
			'keybind': 'Bližnjica',
			'learn':'Learn',
			'shift': 'Shift',
			'alt': 'Alt',
			'delete':'Delete',
			'save': 'Shrani',
			'note':'Zaznamki',
		},
		'markersTable':{
			'name':'Ime',
			'startTime': 'Začetni čas',
			'endTime': 'Konči čas',
			'type': 'Tip'
		}
	},
	'calendar':{
		'title': 'Koledar',
		'noise':'Hrup',
		'audio':'Avdio',
		'weather':'Vreme',
		'video':'Video',
		'adio':'ADIO',
	},
	'streamPopover':{
		'title':'V Živo',
		'Audio':'Avdio',
		'Video':'Video',
		'StartManRec': 'Ročno snemanje',
		'StopManRec': 'Ustavi snemanje',
		'StartStream': 'Predvajaj',
		'StopStream': 'Ustavi predvajanje',
	},
	'download':{
		'title':'Prenesi',
		'popOver':{
			'XML':'XML podatki',
			'XMLWeekly':'tedenski XML podatki',
			'Raw':'Surovi podatki',
			'Global':'Globalne vrednosti',
			'weather':'TXT vremenski podatki',
		}
	},
	'archives':{
		'popOver':{
			'Global':'Globalne vrednosti',
			'Noise':'Hrup',
			'Audio':'Avdio',
			'Video':'Video',
			'Weather':'Vreme',
			'Adio': 'ADIO',
			'Compressed': 'KOMPRIMIRANO',
		},
		'audioPopOver':{
			'downlRec': 'Prenesi posnetek',
			'range': 'Območje',
		},
		'video':'VIDEO',
		'global':'GLOBALNE VREDNOSTI',
		'weather':'VREME',
		'noise':'HRUP',
		'audio':'AVDIO',
		'name':'Arhiv',
		'Delete':'Izbriši',
		'Download':'Prenesi',
		'NorReview':'NorReview',
		'Thumbnail':'Slika',
		'Filename':'Datoteke',
		'Duration':'Dolžina',
		'Size':'Velikost',
		'Close':'Zapri',
		'adio': 'ADIO',
		'compressed': 'KOMPRIMIRANI PODATKI',
	}, 
	'settings':{
		'name':'NASTAVITVE',
		'save':'SHRANI',
		'addButt':'DODAJ',
		'preTrigg': 'Pred-Sprožilec',
		'Trigg': 'Sprožilec',
		'postTrigg':'Po-Sprožilec',
		'warning': 'Obvestilo',
		'continue': 'Nadaljuj',
		'cancel': 'Prekliči',

		'interface':{
			'settingsName':'Grafični vmesnik',
			'Realtime display':'Dolžina relanega prikaza [sek]',
			'Language':'Jezik',
			'Lt':'Y-območje za graf hrupa',
			'Spectrum':'Y-območje spektra',
			'Weather':'Y-območje vremenskih podatkov',
			'Adio': 'Y-območje ADIO naprave',
			'Manual':'Ročno območje',
			'Dynamic':'Dinamično Območje',
			'noiseTriggerLevel':'Sprožilec ravni hrupa',
			'spectrumTriggerLevel':'Sprožilec ravni spektra',
			//Options
			'english':'Angleščina (EN)',
			'austria':'Nemščina (AT)',
			'german':'Nemščina (DE)',
			'french':'Francoščina (FR)',
			'slovensko':'Slovenščina (SLO)',
		},
		'download':{
			'settingsName':'Prenosi',
			'Compression':'Kompresija podatkov',
			'No compression':'Brez kompresije',
			'Zip compression':'Zip kompresija podatkov (prihrani pasovno širino)',
			'Noise':'Hrup',
			'Weather':'Vremenski podatki',
			'Global Values':'Globalne vrednosti',
			'Special values':'Posebne vednosti',
			'Audio':'Avdio',
			'Video':'Video',
			'Markers':'Markerji',
			'Statistics':'Statistika',
			'statisticsTemplate':'Oblika',
			'statisticsRename':"Preimenuj Obliko"
		},
		'audioRecording':{
			'settingsName':'Avdio snemanje',
			'Format':'Avdio format',
			'Audio Offset':'Avdio pred-snemanje: [s]',
			'Day':'Dnevni sprožilec',
			'Night':'Nočni sprožilec',
			'Optional 1':'Opcijski sprožilec 1',
			'Optional 2':'Opcijski sprožilec 2',
			'RecDur':'Dolžina posnetka (s)',
			'Threshold':'Raven (dBA)',
			'Start':'Začetni čas (HH)',
			'Stop':'Končni čas (HH)',
			'Weather':'Vremenski sprožilci',
			'Windspeed':'Hitros vetra',
			'Temperature':'Temperatura',
			'Air':'Zračni pritisk',
			'Precipitation':'Padavine',
			'Humidity':'Vlažnost',
			//Options
			'Disable':'Izklopi',
			'Lower':'Nižja kot',
			'Greater':'Višja kot',
			'Both':'Dvojni sprožilec',
			'lowerThan':'Nižja kot',
			'greaterThan':'Višja kot',
		},
		'dynamicDns':{
			'settingsName':'Dinamični DNS',
			'Address':'Naslov',
			'Provider':'Ponudnik',
			'Username':'Up. ime',
			'Password':'Geslo',
			'IP':'IP',
		},
		'alertMessaging':{
			'settingsName':'Pošiljanje obvestil',
			'createGroupButton':'Ustvari novo skupino',
			'createGroupDialog':'Ali ste prepričani da želite ustvariti novo skupino?',
			'deleteGroupDialog':'Ali ste prepričani da želite izbrisati skupino?',
			'deleteEmailDialog':'Ali ste prepričani da želiet izbrisati E-mail/telefonsko številko?',
			'dialogConfirm':'Potrdi',
			'dialogContinue':'Nadaljuj',
			'dialogCancel':'Prekliči',
			'MSISDN-E-Mail':'V katero skupino/e želite dodati prejemnika/e?',
			'Add MSISDN':'Dodaj mobilno številko (MSISDN)',
			'Add E-mail':'Dodaj E-mail',
			'DeleteButton': 'Izbriši',
			'DeleteGroup':'Izbriši skupino',
			'DeleteRecip': 'Izbriši prejemnika',
			'DeleteEmail':'Izbriši E-mail / Telefonsko št.',
			'TestEmail':'Pošlji testni E-mail',
			'Resend after':'Ponovno pošlji',
			'Threshold day':'Dnevni sprožilec',
			'Threshold Night':'Nočni sprožilec',
			'Threshold Opt 1':'Opcijski sprožilec 1',
			'Threshold Opt 2':'Opcijski sprožilec 2',
			'Running Average Level':'Raven drsečega povprečja',
			'Weather trigger': 'Vremenski sprožilec',
			'System reboot':'Ponovni zagon',
			'Connection with meter lost':'Napaka v komunikaciji z Nor140',
			'FTP server error':'Napaka v FTP povezavi',
			'Critical memory on meter':'Polna spominska kartica na Nor140',
			'Critical disk space':'Polni Disk',
			'Microphone check error':'Napaka pri preverjanju mikrofona',
			'Battery mode':'Baterijski način',
			'Connection with Weather station lost':'Napaka v komunikaciji z vremensko postajo',
			'LEQ':'LEQ Day',
			'Inbound (MSISDN)':'Dohodna sporočila (MSISDN):',
			'Status':'Status:',
			'GPS':'GPS:',
			'Threshold change':'Raven sprožilca:',
			'Email settings':'Email nastavitve',
			'Sender Email':'Email pošiljatelja',
			'Password':'Geslo',
			'SMTP server':'SMTP strežnik',
			'SMTP port':'SMTP vrata',
			'noRepeat':'Ne ponavljaj',
			'resendAft':'Ponovno pošlji',
			//Options
			'min':'min',
			'disabled':'Izklopi',
			'groupsError':'Izberi Skupino/e!',
			'emailSent':'Email/SMS uspešno poslan'
		},
		'FTPSending':{
			'settingsName':'FTP sinhronizacija',
			'FTP Address':'FTP Naslov',
			'Refresh Rate':'Hitrost osveževanja',
			'Username':'Up. ime',
			'Password':'Geslo',
			'Port':'Vrata',
			'Values':'Vrednosti za pošiljanje',
			//Options
			'Disable':'Izklopi',
			'sec':'sek',
			'min':'min',
			'hour':'ure',
			'measur':'Hrup',
			'weath':'Vreme',
			'audio':'Avdio',
			'global':'Globalne vrednosti',
			'video':'Video',
		},
		'geographicPosition':{
			'settingsName':'Geografski položaj',
			'Latitude':'Zemljepisna širina [°]',
			'Longitude':'Zemljepisna dolžina [°]',
			'Height':'Višina [m]',
		},
		'weather':{
			'settingsName':'Vreme',
			'Weather':'Vremenska postaja',
			'values':'Vrednosti',
			'SetDevice':'Nastavi napravo',
			//Options
			'NoWeather':'Brez vremenske postaje',
			'reinhardt':'Reinhardt MWS 5MV',
			'reinhardtRain':'Reinhardt MWS 5MV s senzorjem za dež',
			'thiesClima':'Thies Clima sensor US',
			'vaisala':'Vaisala WXT520',
			'kw360': 'ONWA KW-360',
		},
		'delete':{
			'settingsName':'Izbriši/Komprimiraj',
			'autoDelete':'Samodejno brisanje podatkov starejših od',
			'autoCompress':'Samodejno komprimiranje podatkov starejših od',
			'Disable':'Izključi',
			'Manual delete':'Ročno brisanje',
			'Values':'Vrednosti',
			'Delete':'Izbriši',
			//Options
			'day':'dan',
			'week':'teden',
			'month':'mesec',
			'measur':'Hrup',
			'weath':'Vreme',
			'audio':'Avdio',
			'global':'Globalne vrednosti',
			'logs':'Dnevnik logov',
			'statistics':'Statistika',
			'video':'Video',
			'adio':'ADIO'
		},
		'device':{
			'settingsName':'Nor 140',
			'Selection':'Tip mikrofona',
			'Polarisation':'Polarizacija mikrofona',
			'Frequency':'Frekvenčni filter',
			'Resolution':'Ločljivost',
			'Duration':'Trajanje',
			'Meter':'Meter scale',
			'Values':'Vrednosti',
			'Special':'Posebni parametri',
			'Advance':'Napredno',
			'Mic check':'Vrednost auto-kalibracije [dB]:',
			'Mic check time':'Auto-kalibracija ob [HH]:',
			'SDFreeSpace':'Opozorilo: SD prosto [%]',
			'Restart':'Resetiraj Nor140',
			'Set instrument':'Nastavi napravo',
			'Format':'Formatiraj SD',
			'CheckSD':'Zasedenost SD',
			'formatSDdialog':'Formatiranje SD kartice lahko traja več kot 5min, ste prepričani da želite nadaljevati?',
			'decrease':'Znižaj',
			'increase':'Zvišaj',
			'value':'Način povprečenja',
			'threshold':'Raven (dBA)',
			'timeControlled':'Časovno povprečje',
			'measurementControlled':'Povprečje meritve',
			'start_stop':'Začetni / Končni čas',
			'startTime':'Začetni čas',
			'endTime':'Končni čas',
			'trigger':'Sprožilec',
			'duration':'Trajanje [s]',
			'test':'Testiraj',
			'testOpt': 'Testiraj opcije Nor140',
			'restartNoise':'Resetiraj Nor140',
			'increasedVol': 'Povečana glasnost',
			'decreasedVol': 'Zamanjšana glasnost',
			'autostart': 'Auto Start-Stop',
			//Options
			'On':'Vklopljena',
			'Off':'Izklopljena',
			'Standard':'Standardni',
			'Disable':'Izklopi',
			'iepe':'IEPE',
			'line':'Linijski',
			'horizontal':'1214/16/17 Horizontalni',
			'vertical':'1214/16/17 Vertikalni',
			'11octave':'1/1 Oktava',
			'13octave':'1/3 Oktava',
			'11wOctave':'1/1w Oktava',
			'13wOctave':'1/3w Oktava',
			'movingAverage':'Drseče povprečje',
			'movingValue': 'Drseča vrednost',
			'midnight': "Polnoči - 00h",
			'noon': "Poldan - 12h",
			'freeSpace': 'SD Prosto: ',
			'instrumentSent': 'Naprava nastavljena',
			'start':'Start',
			'stop':'Stop',
			'days':'Dan',
			'types':'Tip meritve',
			'startstopActive':'Aktiviraj',
			'warningMeasRunning':'Instrument ne bo nastavljen, ker je meritev aktivna!'
		},
		'video':{
			'settingsName':'Video',
			'Present':'Naprava',
			'Manual':'Ročno snemanje',
			'Triggering':'Video snemanje s sprožilci hrupa',
			'Moving detection':'Detekcija gibanja',
			'Settings':'Nastavitve',
			'Pre':'Pred-snemanje',
			'Post':'Po-snemanje',
			'No device':'Brez naprave',
			'Video camera':'Video kamera',
			'SetDevice': 'Pošlji nastavitve',
			'formatSDWarning': 'Prosimo počakajte dokler ne vidite SD Prosto: 100%',
		},
		'adio':{
			'settingsName':'ADIO',
			'Present':'Naprava',
			'ADIO':'ADIO Naprava',
			'NoDevice':'Brez naprave',
			'DigitalOut':'Digitalni izhod',
			'DigitalIn':'Digitalni vhod',
			'AnalogIn':'Analogni vhod',
			'AnalogOut':'Analog izhod',
			'AnalogLowerLimit':'Spodnja meja analognega kanala 0V / 4mA',
			'AnalogUpperLimit':'Zgornja meja analognega kanala 10V / 20mA',
			'Pleaseinput':'"Prosim vnesite"',
			//Options
			'On':'On',
			'Off':'Off',
		},
		'norcloud':{
			'settingsName':'NorCloud',
			'IdNor':'Nor140 ID',
			'syncTime':'Interval pošiljanja',
			'syncData': 'Pošlji podatke o hrupu',
			'syncRec': 'Pošlji Audio posnetke',
			'sendAlerts': 'Pošlji obvestila',
			'recSett': 'Sprejmi nastavitve iz serverja',
			'applySett': 'Posodobi sprejete nastavitve ',
			//Options
			'On':'Vklopljen',
			'Off':'Izklopljen',
			'disable':'Ne pošiljaj',
			'min':'minut',
			'hour':'ur',
			'now': 'Takoj, ob sprejetju',
			'fhour': 'Ob polni uri',
			'break': 'Ko se izvede Automic check',
		},
		'statistics':{
			'settingsName':'Statistika',
			'reportSending':{
				'settingsName': 'Avtomatsko pošiljanje Poročil',
				'Name': 'Ime',
				'Title': 'Naslov',
				'Duration': 'Dogodek',
				'Days': 'Pošlji ob dnevih',
				'Hours': 'Pošlji ob uri',
				'Range': 'Dnevi nazaj',
				'Email': 'E-mail', 
				'Language':'Jezik'
			},
			'options': {
				'Range': 'Od-Do',
				'Daily': 'Dnevno',
				'On Event': 'Ob dogodku',
			}
		},
		'status':{
			'settingsName':'Sistem',
			'Reboot':'Ponovni zagon sistema',
			'Reboot confirm': 'Ali ste prepričani da želite ponovno zagnati sistem?',
			'Reboot success': 'Manj kot 1min do ponovnega zagona!',
			'Reboot cancel': 'Ponovni zagon preklican',
			'Restart confirm':'Ali ste prepričani da želite ponovno zagnati N140?',
			'Restart Warning': 'N140 bo ponovno dosegljiv v 1min!',
			'Restart success': 'N140 je ponovno dosegljiv!',
			'Restart cancel': 'Operacija preklicana',
			'Version':'Verzija',
			'Release':'Datum izdaje',
			'PCFree':'Opozorilo: disk PC-ja [%]',
			'SDD':'SSD',
			'memory':'Pomnilnik',
			'camera':'Kamera SD',
			'n140':'Nor140 SD',
			'cpu':'Obremenjenost CPE',
			'firmware':'Firmware',
			'logs':'Dnevnik dogodkov',
			'download':'Prenesi',
			'total':'SKUPAJ',
			'free':'PROSTO',
			'used':'ZASEDENO',
			'gbOrMore':'2GB ali več',
			'of':'od',
			'users': 'Uporabniki',
			'username':'Up. Ime',
			'password':'Geslo',
			'adminUsr': 'Admin',	
			'noiseUsr': 'Uporabnik',
			'guestUsr': 'Gost'		
        	}
	},
	'errors':{
		'n140':'Nor140',
		'weather': 'VREMENSKA POSTAJA',
		'adio': 'ADIO',
		'cameraSD':'CAMERA SD Kartica je zasedena več kot 80%!'
	},
	'codes':{
		"13":"Ni serijske povezave",
		"16":"Nanjkajoče programske opcije",
		"64":"OK-brez napak",
		"89":"Čas meritve predolg za Synchro opcijo",
		"90":"Nepoznani ukaz",
		"91":"Opcija ni prisotna",
		"92":"I/O zaklenjen",
		"93":"No marker table for selected file",
		"94":"Predolg ukaz brez ločilnih znakov",
		"97":"Nepoznana naprava",
		"99":"Manjkajoči DECT modul",
		"100":"Ni digitalnega signala",
		"101":"Nepravilna številka ukaza",
		"102":"Predolg Text",
		"104":"Neveljavni podatki",
		"105":"Številka izven dovoljenega območja",
		"106":"Meritev ne deluje",
		"108":"Čas je potekel za izvedbo ukaza",
		"109":"Software v2.x option no present (118)",
		"110":"Napaka v tekstovnem formatu",
		"111":"Software v3.x option not present (118)",
		"112":"Poln Pomnilnik",
		"116":"Vse operacije onemogočene zaradi napak v pomnilniku",
		"117":"Napak pri kalibraciji merilnika",
		"118":"Nepoznana napaka",
		"119":"Nepoznana napaka",
		"121":"Direktorij ni nastavljen",
		"122":"Manjkajoči direktorij",
		"123":"Oprecije pomnilnika OK",
		"124":"Manjkajoča SD Kartica",
		"125":"SD Kartica nima napajanja",
		"126":"SD Kartica zaklenjena za pisanje"
	}
}


// WEBPACK FOOTER //
// ./src/localization/translations/local-SL.js